import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';
import { TValidOtpRequest } from '~/store/otp-verification/types.ts';

export const validateOtp = createAsyncThunk(
  'otp/validateOtp',
  async (data: TValidOtpRequest, { rejectWithValue }) => {
    try {
      const response = await api.post(`/identification/otp/validate`, data);
      return response.data;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
